var pym = require("./lib/pym");
require("./lib/webfonts");

// If sortable:
// window.Tablesort = require('./lib/tablesort');
// Tablesort(document.querySelector("#state-table"))

var $ = require("./lib/qsa");
var dot = require("./lib/dot");
var templateSource = require("./_content.html");
var template = dot.compile(templateSource);

async function init(pymChild) {
  if (window.location.hostname == "apps.npr.org") {
    var request = await fetch("https://apps.npr.org/dailygraphics/data/sheets/trump-calendar-20240205.json");
    // console.log(request); 
    var copy = await request.json();
    var data = copy;
    var content = template(data);
    var graphicEl = $.one("#table-graphic");

    graphicEl.innerHTML = content;
  }
  pymChild.sendHeight();
}

var onWindowLoaded = function () {
  pym.then(child => {
    init(child);
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);